import type { SxProps, Theme } from '@mui/material';

export const spreadsOverviewHeadingSx: SxProps<Theme> = {
  textAlign: 'center',
  mb: 4,
  fontSize: { xs: '1.5rem', sm: '2rem' },
};

export const spreadsOverviewGridSx: SxProps<Theme> = {
  justifyContent: 'center',
};
